import { Component, OnInit,TemplateRef,ViewChild } from '@angular/core';
import { LoadService } from '../../services/load.service';
import {FormGroup,FormControl,Validators} from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {LotesService} from '../../services/lotes.service';
import {ProductsService} from '../../services/products.service';
import {RendimientoService} from '../../services/rendimiento.service';

@Component({
  selector: 'app-rendimiento',
  templateUrl: './rendimiento.component.html',
  styleUrls: ['./rendimiento.component.css']
})
export class RendimientoComponent implements OnInit {
@ViewChild('lots2Select') lots2Select;
public modalRef: BsModalRef;
public formCreate:FormGroup;
public formEdit:FormGroup;
public lots:any[];
public products:any[];
public data_list:any[];
public links:any;
public meta:any;
public alert:any;
public isopen:any;
public product_selected:any;
public lot_selected:any;
public settings = {
  columns:{
    lot_id:{
      header:"Lote",
      type:"obj",
      tipo:"lote",
      path:"attributes.lot_code",
      filter: { visible:true, default:'asc',type:"dd" }
    },
    product_id:{
      header:"Producto",
      type:"obj",
      tipo:"product",
      path:"attributes.product_code",
      filter:{ visible:true, default:'asc',type:"dd"}
    },
    distribution:{
      header:"Distribución",
      type:"number",
      path:"attributes.distribution",
      filter:{visible:true, default:'asc',type:"number"}
    },
    average:{
      header:"Rendimiento",
      type:"number",
      filter:{visible:true, default:'asc',type:"number"}
    }
  },
  actions:{
    edit: true,
    view: false,
    delete: false,
    close:false,
  }
}
  constructor(private _loaddata:LoadService,
              private modalService:BsModalService,
              private lotesService:LotesService,
              private productsService:ProductsService,
              private rendimientoService:RendimientoService) {
    this.lots = [];
    this.products = [];
  }

  ngOnInit() {
    this.alert = '';
    this.isopen = false;
    this.lots = [];
    this.products = [];
    this.product_selected = {};
    this.lot_selected = {};
    this.formCreate = new FormGroup({
      'id': new FormControl('',Validators.required),
      'lot_id': new FormControl('',Validators.required),
      'product_id':new FormControl('',Validators.required),
      'distribution':new FormControl('',Validators.required),
      'average': new FormControl('',Validators.required)
    });

    this.formEdit = new FormGroup({
      'id': new FormControl('',Validators.required),
      'average': new FormControl('',Validators.required),
      'distribution':new FormControl('',Validators.required)
    });

    this.loadAverages();
    this.loadLotes();
  }

/*carga los rendimientos para la tabla*/
  loadAverages(){
    this.rendimientoService.get().subscribe((response:any)=>{
      //console.log('rendimientos',response);
      this.data_list = response.data;
      this.links = response.links;
      this.meta = response.meta;
    },(error)=>{
      //console.log('no se han cargado los rendimientos',error);
    })
  }

/*carga todos los lotes*/
  loadLotes(){
    this._loaddata.loadChange(30);
    this.alert = 'Cargando Lotes';
    this.isopen = true;
    this.lotesService.getAllLotes().subscribe((response:any)=>{
      //console.log('lotes',response);
      this._loaddata.loadChange(60);
      this.isopen = false;
      this.lots = response.data;
      // response.data.forEach(element=>{
      //   this.lots.push({id:element.id,code:element.attributes.code});
      // });
      let data = response.data;
      let lots:string = "{";
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          lots+='"'+data[key].id+'":"'+data[key].attributes.code+'",';
        }
      }
      lots = lots.slice(0,-1);
      lots+="}";
      this.settings.columns.lot_id.filter['data']= lots;
      this.loadProducts();
    },(error)=>{
      this.showError(error.error.error);
      //console.log('no se cargaron los lotes',error);
    })
  }

/*carga todos los productos*/
  loadProducts(){
    this._loaddata.loadChange(60);
    this.alert = 'Cargando Productos...';
    this.isopen = true;
    this.productsService.getAll().subscribe((response:any)=>{
      //console.log('productos',response);
      this._loaddata.loadChange(100);
      this.alert = 'Productos Cargados';
      this.onClosedAutomatic();
      this.products = response.data;
      // response.data.forEach(element=>{
      //   this.products.push({id:element.id,code:element.attributes.code});
      // });
      let data = response.data;
      let products:string = "{";
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          products+='"'+data[key].id+'":"'+data[key].attributes.code+'",';
        }
      }
      products = products.slice(0,-1);
      products+="}";
      this.settings.columns.product_id.filter['data']= products;
    },(error)=>{
      //console.log('no se cargaron los productos',error);
      this.showError(error.error.error);
    })
  }

/*carga los datos de acuerdo a los filtros aplicados*/
  loadDataFiltered(filters){
    //console.log('filtrando',filters);
    this.rendimientoService.getDataFiltered(filters)
    .subscribe(
      (response:any) =>{
        this.data_list = response.data;
        //console.log('respuesta filtro',response);
        this.links = response.links;
        this.meta = response.meta;
      },
      (error) => {

      }
    );
  }

/*abre modal para crear rendimiento*/
  openNewAverage(template){
    //console.log('cargando lotes');
    this.openModal(template);
  }

  /*abre modal para editar un rendimiento*/
  showEditForm(index,template){
    let item = this.data_list[index];
    this.formEdit.patchValue({
      'id':item.id,
      'distribution':item.attributes.distribution,
      'average':item.attributes.average,
    });
    // this.product_selected = {label:item.attributes.product_code,value:item.attributes.product_id};
    // this.lot_selected = {label:item.attributes.lot_code,value:item.attributes.lot_id};
    //this.lots2Select.select(item.attributes.lot_id);
    this.openModal(template);

  }

  /*envia un post para actualizar el rendimiento*/
  sendEditAverage(){
    this._loaddata.loadChange(30);
    this.alert = 'Editando Rendimiento';
    this.isopen = true;
    let id = this.formEdit.get('id').value;
    let average = this.formEdit.get('average').value;
    let distribution = this.formEdit.get('distribution').value;
    let body = this.rendimientoService.getJsonEdit(id,average,distribution);
    this.rendimientoService.editAverage(body,id).subscribe((response:any)=>{
      //console.log('rendimiento actualizado',response);
      this.loadAverages();
      this.alert = 'Rendimiento Actualizado';
      this._loaddata.loadChange(100);
      this.cerrarModal();
    },(error)=>{
      //console.log('no se ha podido actualizar el rendimiento',error);
      this.showError(error.error.error);
      this.cerrarModal();
    })
    //console.log(this.product_selected,this.lot_selected,this.formEdit);
  }

/*abre el modal*/
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

/*cierra el modal*/
  cerrarModal(){
    this.modalRef.hide();
  }

/*envía un post para crear rendimiento*/
  sendNewAverage(){
    this._loaddata.loadChange(30);
    this.alert = 'Creando Rendimiento...';
    this.isopen = true;
    let lot_id = this.formCreate.get('lot_id').value;
    let product_id = this.formCreate.get('product_id').value;
    let average = this.formCreate.get('average').value;
    let distribution = this.formCreate.get('distribution').value;
    let body = this.rendimientoService.getJsonCreate(lot_id,product_id,average,distribution);
    this.rendimientoService.createAverage(body).subscribe((response:any)=>{
      //console.log('rendimiento creado',response);
      this._loaddata.loadChange(100);
      this.alert = 'Rendimiento Creado';
      this.onClosedAutomatic();
      this.loadAverages();
      this.clearForm();
      this.cerrarModal();
    },(error)=>{
      //console.log('no se ha podido crear el rendimiento',error.error);
      this.showError(error.error.error);
    });
  }

/*
*borra el formulario de crear rendimiento
*/
  clearForm(){
    this.formCreate.reset();
    this.formCreate.patchValue({
      'lot_id':'',
      'product_id':'',
      'average':'',
      'distribution':''
    });
  }

  /**
   * Actualiza el listado por la paginacion
   * @param data nuevo listado o mensaje de error.
   */
    updateData(data:any):void{
      if(data === "Error al cargar listado."){
        this.showError(data);
      }
      else{
        this.data_list = data;
      }
    }

    /*muestra un mensaje de error por medio del alert*/
    showError(msg:string){
      if(msg == undefined){
        this.alert = 'No tiene permisos para realizar la acción.';
      }
      else{
        this.alert = msg;
      }
      this._loaddata.loadChange(100);
      this.isopen =true;
    }

/*cierra el alert*/
    onClosed(dismissedAlert: any): void {
      this.isopen = false;
    }

    /**
    * Cierra el mensaje de alerta despues de 3 segundos
    */
    onClosedAutomatic(): void {

        setTimeout(()=>{
        this.isopen = false;
      }, 3000);

    }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/rendimiento/rendimiento.component.ts